import React, { ElementType } from 'react';

import {
  ListItemButton,
  ListItemButtonProps as MUIListItemButtonProps,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router';

interface ListItemButtonProps extends MUIListItemButtonProps {
  component?: ElementType;
  href?: string;
  target?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement> & React.MouseEventHandler<HTMLSpanElement>;
}

const ListItemButtonLink = React.forwardRef<HTMLAnchorElement, ListItemButtonProps>(
  ({ children, href, onClick, target, style, ...rest }, ref) => {
    const navigate = useNavigate();
    const theme = useTheme();

    return (
      <ListItemButton
        ref={ref}
        component='a'
        onClick={(e: any) => {
          if (onClick) {
            onClick(e);
          }
          if (!e.metaKey && href && !(href.startsWith('http://') || href.startsWith('https://'))) {
            e.preventDefault();
            e.stopPropagation();
            if (target) {
              window.open(`${window.location.origin}${href}`, target);
            } else {
              navigate(href);
            }
          }
        }}
        href={href}
        target={target}
        // This style cannot be pulled out as a styled-component, as the "component" prop
        // isn't forwarded correctly by MUI. Without the component="a" prop being passed
        // through, href and target are invalid props for ListItemButton.
        style={{
          borderRadius: `${theme.shape.borderRadius}px`,
          ...style,
        }}
        {...rest}
      >
        {children}
      </ListItemButton>
    );
  }
);

ListItemButtonLink.displayName = 'ListItemButtonLink';

export default ListItemButtonLink;
